<template>

  <b-container fluid>
    <b-row class="mb-3 mt-3">
      <b-col><ViewPathWidget /></b-col>
    </b-row>

    <b-row>
      <ComplexInterviewComponent v-if="interviewDetails && interviewDetails.complex" :interview-details="interviewDetails.complex"/>
      <SimpleInterviewComponent  v-if="interviewDetails && interviewDetails.simple" :interview-details="interviewDetails.simple"/>
    </b-row>

  </b-container>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import InterviewService from "../../services/InterviewService";
import SimpleInterviewComponent from "@/views/interview/SimpleInterviewComponent";
import ComplexInterviewComponent from "@/views/interview/ComplexInterviewComponent";
import ViewPathWidget from "@/views/dynpage/widgets/ViewPathWidget";

export default {
  name: 'InterviewPage',

  data() {
    return {
      interviewDetails: null
    }
  },

  components: {
    SimpleInterviewComponent, ComplexInterviewComponent, ViewPathWidget
  },

  computed: {
    ...mapState(['activeSurvey', 'absoluteDrillPath']),
    ...mapGetters(['realmName', 'studyName', 'authToken', 'pageByName', 'completePath']),

  },

  methods: {
    loadInterviewDetails(path) {
      InterviewService.getInterviewDetails(this.authToken, this.realmName, this.studyName, path).then((response) => {
        this.interviewDetails = response.data
        this.$store.commit('setNodeInfo', response.data.nodeInfo)
      })
    }

  },

  watch: {
    $route: {
      handler() {
//        const externId = this.$route.params.externId
        const drillPath = this.$route.params.path
        this.$store.commit('setCompleteDrillPath', drillPath)
        this.loadInterviewDetails( this.completePath )
      },
      immediate: true
    },

  }

}
</script>